const serverProtocol = 'http://'
export const fullURL = window.location.href
export const rootURL = ''
export const baseURL = '/api/v1'
// export const rootURL = process.env.NODE_ENV === 'production'
// 	? serverProtocol + 'localhost:8000'
// 	: ''
// export const baseURL = process.env.NODE_ENV === 'production'
// 	? serverProtocol + 'localhost:8000/api/v1'
// 	: '/api/v1'

export const mapboxAPIKey =
	'pk.eyJ1Ijoibmlja2FyZWlhcyIsImEiOiJjajk3ZWY5ejcwNjh5MnhxbTdkcWh2dWRiIn0.L1Txw72Q7r_ja5JgMJ_86g'

// wrkprty api key (unrestricted)
export const googleMapsAPIKey = 'AIzaSyCkUFgRM2V7VjNbi0MUu1Uo2rGH5JA-vIY'

// wrkprty api key (restricted)
// export const googleMapsAPIKey = 'AIzaSyCSuqFj9nRTCmciqn6BRM9EDKz2VDqZIfQ'

// test api key
// export const googleMapsAPIKey = 'AIzaSyADb8Lat0jTbpQWE890j6EDdtNCi_1qPu8'

// ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! !
// NEVER CHANGE THE KEY ONLY CHANGE THE VALUE
// Changing value is what changes the display name
// ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! !
export const eventRestrictionOptions = {
	restrictions: {
		type: ['header'],
		women_only: { icon: 'fal fa-female', value: 'Women only' },
		parents_only: {
			value: 'Parents only',
			min_child_age: {
				icon: 'fal fa-child',
				type: ['int'],
				value: 'Min Child Age'
			},
			max_child_age: {
				icon: 'fal fa-child',
				type: ['int'],
				value: 'Max Child Age'
			},
			icon: 'fal fa-child'
		},
		occupation_or_interest: {
			occupation_or_interest_input: {
				icon: 'fal fa-info',
				type: ['text', 'multi'],
				value: 'Occupation or Interest'
			},
			value: 'Specific occupation or interest'
		},
		value: 'This event is open to:'
	}
	// 'age_range': {
	// 	value: 'Age range',
	// 	'min_age': {icon: 'fal fa-user', type: ['int'], value: 'Min age'},
	// 	'max_age': {icon: 'fal fa-user', type: ['int'], value: 'Max age'},
	// }
}

// ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! !
// NEVER CHANGE THE KEY ONLY CHANGE THE VALUE
// Changing value is what changes the display name
// ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! !
export const eventProvisionsOptions = {
	beverages: {
		type: ['header'],
		coffee: { icon: 'fal fa-coffee', value: 'Coffee' },
		tea: { icon: 'fal fa-coffee', value: 'Tea' },
		water: { icon: 'fal fa-tint', value: 'Water' },
		other_beverage: {
			other_beverage_input: {
				icon: 'fal fa-glass',
				type: ['multi', 'text'],
				value: 'Other beverage'
			},
			value: 'Other'
		},
		value: 'Beverages'
	},
	food: {
		type: ['header'],
		fruit: { icon: 'fal fa-utensils', value: 'Fresh fruit' },
		pastries: { icon: 'fal fa-utensils', value: 'Pastries' },
		other_snacks: {
			other_snack_input: {
				icon: 'fal fa-utensils',
				type: ['multi', 'text'],
				value: 'Other snack'
			},
			value: 'Other'
		},
		value: 'Snacks'
	}
}

// ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! !
// NEVER CHANGE THE KEYS ONLY CHANGE THE VALUE
// Changing value is what changes the display name
// ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! ! !
export const locationInfoOptions = {
	basics: {
		type: ['header'],
		business_tools: {
			type: ['header'],
			wifi: { icon: 'fal fa-wifi', value: 'Wifi' },
			ethernet: { icon: 'fal fa-bolt', value: 'Ethernet' },
			printer: { icon: 'fal fa-print', value: 'Printer' },
			copier: { icon: 'fal fa-print', value: 'Copier / Scanner' },
			monitors: { icon: 'fal fa-desktop', value: 'Projector / Extra monitors' },
			call_area: {
				icon: 'fal fa-phone',
				value: 'Phone call area (to help reduce noise)'
			},
			value: 'Internet / business tools'
		},
		power_outlets: {
			type: ['header', 'radio'],
			icon: 'fal fa-plug',
			radio_vals: {
				plenty: { value: 'Plenty' },
				limited: { value: 'Limited' },
				none: { value: 'None' }
			},
			value: 'Power outlets'
		},
		lighting: {
			type: ['header', 'radio'],
			icon: 'fal fa-lightbulb',
			radio_vals: {
				natural: { value: 'Natural' },
				bright: { value: 'Bright' },
				mixed: { value: 'Mixed' }
			},
			value: 'Lighting'
		},
		noise_level: {
			type: ['header', 'radio'],
			icon: 'fal fa-volume-up',
			radio_vals: {
				quiet: { value: 'Quiet' },
				moderate: { value: 'Moderate' },
				noisy: { value: 'Noisy' }
			},
			value: 'Noise level'
		},
		bathrooms: {
			type: ['header', 'radio'],
			icon: '003-toilet.svg',
			radio_vals: {
				'0': { value: '0' },
				'1': { value: '1' },
				'2+': { value: '2+' }
			},
			value: 'Bathrooms'
		},
		kitchen_access: {
			type: ['header'],
			coffee_maker: { icon: '005-coffee-maker.svg', value: 'Coffee maker' },
			microwave: { icon: '009-microwave-oven.svg', value: 'Microwave' },
			refrigerator: { icon: '013-refrigerator.svg', value: 'Refrigerator' },
			dishes: { icon: 'fal fa-utensils-alt', value: 'Dishes & silverware' },
			stove: { icon: '004-stove.svg', value: 'Stove & utensils' },
			value: 'Kitchen access'
		},
		value: 'Basics'
	},
	nice: {
		type: ['header'],
		outdoor_areas: {
			patio: { icon: '011-patio.svg', value: 'Patio' },
			balcony: { icon: '001-balcony.svg', value: 'Balcony' },
			garden: { icon: '008-garden.svg', value: 'Garden' },
			pool: { icon: '006-swimming-pool.svg', value: 'Pool' },
			hot_tub: { icon: '006-swimming-pool.svg', value: 'Hot tub' },
			outdoor_workstation: {
				icon: '011-patio.svg',
				value: 'Outdoor workstation'
			},
			value: 'Outdoor areas'
		},
		fireplace: { icon: 'fal fa-fire', value: 'Fireplace' },
		air_conditioning: { icon: 'fal fa-snowflake', value: 'Air Conditioning' },
		shower: { icon: 'fal fa-shower', value: 'Shower access' },
		value: 'Other niceties'
	},
	accessibility: {
		type: ['header'],
		pets: {
			dogs: { icon: '012-dog.svg', value: 'Dogs' },
			cats: { icon: '010-cat.svg', value: 'Cats' },
			other_pet: {
				other_pet_input: {
					icon: 'fal fa-paw',
					type: ['multi', 'text'],
					value: 'Pet Types'
				},
				value: 'Other pet(s)'
			},
			value: 'Pets live here'
		},
		wheelchair: { icon: 'fal fa-wheelchair', value: 'Wheelchair accessible' },
		value: 'Accessibility'
	},
	parking: {
		type: ['header'],
		free_on_premises: {
			free_on_premises_input: {
				icon: '002-parking.svg',
				type: ['text', 'multi'],
				value: 'Details...'
			},
			value: 'Free on premises'
		},
		street_parking: {
			street_parking_input: {
				icon: 'fal fa-road',
				type: ['text', 'multi'],
				value: 'Details...'
			},
			value: 'Street parking'
		},
		paid_lot: {
			paid_lot_address: {
				icon: '002-parking.svg',
				type: ['text'],
				value: 'Paid lot address'
			},
			paid_lot_price: {
				icon: '002-parking.svg',
				type: ['money'],
				value: 'Paid lot price'
			},
			value: 'Paid lot'
		},
		value: 'Parking'
	}
}
